<template>
    <div>
        <div class="d-flex align-items-center text-align justify-content-center" 
            style="height: 300px; flex-direction: column"
            v-if="loadingInitial">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <br>
            <p class="mt-2">Loading</p>
        </div>

        <form @submit.prevent="submitForm()" v-else>
            <div class="form-group">
                <label for="example-text-input" class="col-form-label text-left d-block">Periode</label>
                <select id="" class="form-control">
                    <option value="">Tahunan</option>
                    <option value="">Bulanan</option>
                    <option value="">Harian</option>
                </select>
            </div>

            <div class="form-group">
                <label for="example-text-input" class="col-form-label text-left d-block">Persentase</label>
                <select id="" class="form-control">
                    <option value="">Harga Tetap</option>
                    <option value="">Persentase</option>
                </select>
            </div>
            
            <div class="form-group mb-0">
                <label for="example-text-input" class="col-form-label text-left d-block">Nilai</label>
                <input type="text" class="form-control">
            </div>

            <button class="btn btn-success waves-effect waves-light mt-4" :disabled="loading">
                Simpan Pengaturan
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            loadingInitial: false,
        }
    },
}
</script>

<style>

</style>